<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-30">
            Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>
            <div class="content-title padding-5 margin-top-10">
                <div class="roadmap-back-wrapper ipad-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/> <span class="">Back to Success Road Map</span>
                    </router-link>
                </div>
                <div class="roadmap-back-wrapper mobile-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0 ">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-title-wrapper">
                    Anchoring Program
                </div>
                <div class="clear"></div>
            </div>
            <!-- mobile -->
            <div class="mobile-display">
                <div>
                    <img :src="'images/mpower/roadmap/2022/achoring-program-ABN.png'" class="responsive-image" />
                </div>
                <div>
                    <img :src="'images/mpower/roadmap/2022/achoring-program-Mindset.png'" class="responsive-image " />
                </div>
                <div>
                    <img :src="'images/mpower/roadmap/2022/achoring-program-Run2ACE.png'" class="responsive-image " />
                </div>
                <div class="margin-bottom-10">
                    <img :src="'images/mpower/roadmap/2022/achoring-program-CodeConduct.png'" class="responsive-image " />
                </div>
                <!-- <p class="mandatory">*Mandatory Program</p> -->
            </div>

            <!-- ipad -->
            <div class="ipad-display center-width">
                <div class="col-2">
                    <img :src="'images/mpower/roadmap/2022/achoring-program-ABN.png'" class="responsive-image" />
                    <img :src="'images/mpower/roadmap/2022/achoring-program-Mindset.png'" class="responsive-image" />
                </div>
                <div class="col-2 margin-bottom-10">
                    <img :src="'images/mpower/roadmap/2022/achoring-program-Run2ACE.png'" class="responsive-image"/>
                    <img :src="'images/mpower/roadmap/2022/achoring-program-CodeConduct.png'" class="responsive-image" />
                </div>
                <div class="clear"></div>
                <!-- <p class="mandatory">*Mandatory Program</p> -->
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory{
    text-align: left;
    padding-left: 10px;
    color:#6b867f;
}
.ipad-display .mandatory{
    text-align: right;
    padding-right: 20px;
    color:#6b867f;
}
.center-width{
    max-width: 800px;
    margin: 0 auto;
}
.boss-content{
  padding: 10px;
}
.boss-content .boss-content-text1{
  color: #0005D3;
}
.boss-content .boss-content-text2{
  font-style: italic;
  color: black;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Anchoring_program',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#D3D3D3'
            }
        }
    },
    components: {
        RoadmapNav
    },
    mounted(){
        window.scrollTo(0,0);
    }
}
</script>
